import { EventEmitter, Input, Output } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatDivider } from '@angular/material/divider';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatDialogContent, MatDialogActions } from '@angular/material/dialog';

@Component({
    selector: 'app-dialog-structure',
    templateUrl: './dialog-structure.component.html',
    styleUrls: ['./dialog-structure.component.scss'],
    imports: [MatIconButton, MatIcon, MatDivider, CdkScrollable, MatDialogContent, MatDialogActions, MatButton]
})
export class DialogStructureComponent implements OnInit {
  constructor() {}

  @Input() disableAction = false;

  @Input('title') title: string;
  @Input('cancelButton') cancelButton: string = 'CANCEL';
  @Input('submitButton') submitButton: string = 'SAVE';

  @Output('cancel') cancel: EventEmitter<any> = new EventEmitter<any>();
  @Output('submit') submit: EventEmitter<any> = new EventEmitter<any>();

  ngOnInit(): void {}

  onCancel(): void {
    this.cancel.emit();
  }

  onSubmit(): void {
    this.submit.emit();
  }
}
